export default __webpack_public_path__ + "static/image-38-d166e23b3960d57be17b0e414fbd5f64.jpg";